import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackEvent } from 'helpers/Analytics';
import { recordAction } from 'redux/modules/announcements';
import { trackingData } from './announcementContent';
import AnnouncementBannerView from './AnnouncementBannerView';
import useOpenAnnouncement from './useOpenAnnouncement';

/**
 * The announcement banner: below the menu bar, pushing the page down. One at
 * a time, so it waits while any other site banner is showing. Dismissing it
 * is saved on the server, so it stays gone on every device.
 */
const AnnouncementBanner = () => {
  const dispatch = useDispatch();
  const announcement = useSelector(
    (state) => state.announcements.active.banner
  );
  const otherBanner = useSelector((state) => state.banner.banners.length > 0);
  const modalOpen = useSelector((state) => !!state.announcements.active.modal);
  const open = useOpenAnnouncement('banner');

  const visible = !!announcement && !otherBanner && !modalOpen;

  useEffect(() => {
    if (visible) {
      trackEvent(
        'announcement-banner-shown',
        trackingData(announcement, 'banner')
      );
    }
  }, [visible, announcement && announcement.id]);

  if (!visible) {
    return null;
  }

  const banner = announcement.banner;

  const dismiss = () => {
    trackEvent(
      'announcement-banner-dismissed',
      trackingData(announcement, 'banner')
    );
    dispatch(recordAction(announcement.id, 'dismiss-banner'));
  };

  return (
    <AnnouncementBannerView
      announcement={announcement}
      onSecondaryClick={() =>
        trackEvent(
          'announcement-banner-secondary-clicked',
          trackingData(announcement, 'banner')
        )
      }
      onCtaClick={open(announcement, banner.cta_url, {
        event: 'announcement-banner-cta-clicked',
        cta: true,
      })}
      onDismiss={dismiss}
    />
  );
};

export default AnnouncementBanner;
